import '../css/fonts.css';
import '../css/style.css';
import '../css/pages/sobre-nos.css';
import '../css/pages/blog.css';

/* Leaflet CSS e JS */
import 'leaflet/dist/leaflet.css';
import 'leaflet/dist/leaflet.js';

/**
 * Adiciona funcionalidade interativa à página após o carregamento do DOM.
 * Inclui:
 * - Lógica para o menu de navegação fixo mudar de aparência ao rolar.
 * - Lógica para destacar o link de navegação ativo.
 * - Animações de entrada para elementos ao rolar a página.
 * - Lógica dos cards de serviço expansíveis.
 * - Lógica das abas interativas na seção de diferenciais.
 * - Lógica da Central de Operações (Atuação Geográfica) com interatividade avançada.
 * - Lógica do Carrossel de Depoimentos.
 * - Lógica do Diagnóstico Visual Interativo.
 * - Lógica do Acordeão de FAQ com filtro de busca.
 */
document.addEventListener('DOMContentLoaded', () => {

    /**
     * Lógica do menu de navegação fixo.
     */
    const nav = document.querySelector('.top-nav');
    if (nav) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 50) {
                nav.classList.add('scrolled');
            } else {
                nav.classList.remove('scrolled');
            }
        });
    }


    /**
     * Animação de entrada dos elementos ao rolar a página.
     */
    const animatedElements = document.querySelectorAll('.animate-on-scroll');
    if (window.IntersectionObserver) {
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.1 });
        animatedElements.forEach(el => { observer.observe(el); });
    } else {
        animatedElements.forEach(el => el.classList.add('is-visible'));
    }

    /**
     * Funcionalidade do slider de comparação de imagens "antes e depois".
     * Permite arrastar o controle para revelar a imagem por baixo.
     * Suporta eventos de mouse e toque.
     */
    const slider = document.getElementById('comparison-slider');
    if (slider) {
        const handle = slider.querySelector('.comparison-slider__handle');
        const imageAfter = slider.querySelector('.comparison-slider__image-after');
        let isDragging = false;

        const startDrag = (e) => {
            isDragging = true;
            e.preventDefault(); // Previne seleção de texto durante o arrasto
        };

        const stopDrag = () => {
            isDragging = false;
        };

        const onDrag = (e) => {
            if (!isDragging) return;
            // Unifica o evento de clienteX para mouse e toque
            const clientX = e.clientX || e.touches[0].clientX;
            const rect = slider.getBoundingClientRect();

            // Calcula o deslocamento e o limita dentro dos limites do slider
            let offsetX = clientX - rect.left;
            if (offsetX < 0) offsetX = 0;
            if (offsetX > rect.width) offsetX = rect.width;

            const percentage = (offsetX / rect.width) * 100;

            // Atualiza a posição do controle e o recorte da imagem
            handle.style.left = `${percentage}%`;
            imageAfter.style.clipPath = `polygon(0 0, ${percentage}% 0, ${percentage}% 100%, 0 100%)`;
        };

        // Adiciona os event listeners para mouse
        handle.addEventListener('mousedown', startDrag);
        document.addEventListener('mouseup', stopDrag);
        document.addEventListener('mousemove', onDrag);

        // Adiciona os event listeners para toque
        handle.addEventListener('touchstart', startDrag);
        document.addEventListener('touchend', stopDrag);
        document.addEventListener('touchmove', onDrag);
    }

    /**
     * Lógica da Linha do Tempo Animada
     */
    const timeline = document.querySelector('.timeline-wrapper');
    if (timeline) {
        const timelineLine = timeline.querySelector('.timeline-line');
        const timelineItems = timeline.querySelectorAll('.timeline-item');

        const timelineObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if(entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    // Opcional: observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.5 });

        timelineItems.forEach(item => {
            timelineObserver.observe(item);
        });

        const handleTimelineScroll = () => {
            const timelineRect = timeline.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            // Começa a animação quando o topo da timeline está a 80% da altura da tela
            const startPoint = windowHeight * 0.8;

            if (timelineRect.top < startPoint) {
                // Calcula o quanto da timeline já passou pelo ponto de início
                const scrolled = startPoint - timelineRect.top;
                const totalHeight = timelineRect.height;
                const progress = Math.min(scrolled / totalHeight, 1);

                timelineLine.style.height = `${progress * 100}%`;
            }
        };

        window.addEventListener('scroll', handleTimelineScroll);
    }



    /**
     * Lógica do Efeito Spotlight na seção de certificações
     */
    const certificationsSection = document.querySelector('.certificacoes');
    if(certificationsSection) {
        certificationsSection.addEventListener('mousemove', e => {
            const rect = certificationsSection.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;

            certificationsSection.style.setProperty('--spotlight-x', `${x}px`);
            certificationsSection.style.setProperty('--spotlight-y', `${y}px`);
        });
    }

    /**
     * Lógica da Barra de Progresso de Leitura.
     * Atualiza a largura da barra com base na posição de rolagem dentro do corpo do artigo.
     */
    const readingProgressBar = document.querySelector('.reading-progress-bar');
    const articleBody = document.querySelector('.article-body');

    if (readingProgressBar && articleBody) {
        window.addEventListener('scroll', () => {
            const articleTop = articleBody.offsetTop;
            const articleHeight = articleBody.scrollHeight;
            const windowHeight = window.innerHeight;
            const scrollY = window.scrollY;

            // Calcula o quanto o usuário já rolou dentro do artigo
            const scrolledThroughArticle = scrollY - articleTop;

            // A altura total "rolável" do artigo é sua altura total menos a altura da janela
            const scrollableArticleHeight = articleHeight - windowHeight;

            let progressPercentage = 0;
            if (scrolledThroughArticle > 0 && scrollableArticleHeight > 0) {
                progressPercentage = (scrolledThroughArticle / scrollableArticleHeight) * 100;
            }

            // Limita a porcentagem entre 0 e 100
            progressPercentage = Math.min(100, Math.max(0, progressPercentage));

            readingProgressBar.style.width = `${progressPercentage}%`;
        });
    }


    /**
     * Lógica do Diagnóstico Visual Interativo
     */
    const diagnosticContainer = document.getElementById('interactive-diagnostic');
    if (diagnosticContainer) {
        const descContainer = document.getElementById('services-header-desc');
        const interactiveZones = diagnosticContainer.querySelectorAll('.interactive-zone');

        interactiveZones.forEach(zone => {
            zone.addEventListener('mouseenter', () => {
                const targetId = zone.dataset.target;

                descContainer.querySelectorAll('.desc-text').forEach(p => {
                    p.classList.remove('is-active');
                });

                const targetDesc = document.getElementById(targetId);
                if (targetDesc) {
                    targetDesc.classList.add('is-active');
                }
            });

            zone.addEventListener('click', (e) => {
                e.preventDefault();
                const cardTargetId = zone.dataset.cardTarget;
                const targetCard = document.getElementById(cardTargetId);
                if(targetCard) {
                    targetCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });
        });

        diagnosticContainer.addEventListener('mouseleave', () => {
            descContainer.querySelectorAll('.desc-text').forEach(p => {
                p.classList.remove('is-active');
            });
            document.getElementById('desc-default').classList.add('is-active');
        });
    }


    /**
     * Lógica dos Cards de Serviço Expansíveis
     */
    const serviceCards = document.querySelectorAll('.service-card');
    serviceCards.forEach(card => {
        const toggleButton = card.querySelector('.service-card__toggle');
        const detailsPanel = card.querySelector('.service-card__details');

        if (toggleButton && detailsPanel) {
            toggleButton.addEventListener('click', () => {
                const isExpanded = card.classList.contains('is-expanded');
                serviceCards.forEach(otherCard => {
                    if (otherCard !== card && otherCard.classList.contains('is-expanded')) {
                        otherCard.classList.remove('is-expanded');
                        otherCard.querySelector('.service-card__toggle').setAttribute('aria-expanded', 'false');
                        otherCard.querySelector('.service-card__details').setAttribute('aria-hidden', 'true');
                    }
                });
                card.classList.toggle('is-expanded');
                toggleButton.setAttribute('aria-expanded', !isExpanded);
                detailsPanel.setAttribute('aria-hidden', isExpanded);
            });
        }
    });

    /**
     * Lógica das Abas Interativas (Ultimate) na Seção de Diferenciais
     */
    const tabsWrapper = document.querySelector('.diferenciais-tabs-wrapper');
    if (tabsWrapper) {
        const tabsNav = tabsWrapper.querySelector('.diferenciais-tabs-nav');
        const tabs = tabsNav.querySelectorAll('.diferenciais-tab-btn');
        const panels = tabsWrapper.querySelectorAll('.diferenciais-tab-panel');

        const animateCounter = (element, target, duration = 1500) => {
            if (element.hasAttribute('data-animated')) return;
            let start = 0;
            const stepTime = Math.abs(Math.floor(duration / target));
            const timer = setInterval(() => {
                start += 1;
                element.textContent = start;
                if (start >= target) {
                    element.textContent = target;
                    clearInterval(timer);
                }
            }, stepTime);
            element.setAttribute('data-animated', 'true');
        };

        const animateIcon = (tab) => {
            const icon = tab.querySelector('svg');
            if (icon) {
                icon.classList.add('is-animating');
                icon.addEventListener('animationend', () => {
                    icon.classList.remove('is-animating');
                }, { once: true });
            }
        };

        tabsNav.addEventListener('click', (e) => {
            const clickedTab = e.target.closest('.diferenciais-tab-btn');
            if (!clickedTab) return;
            e.preventDefault();
            if (clickedTab.getAttribute('aria-selected') === 'true') return;

            tabs.forEach(tab => tab.setAttribute('aria-selected', 'false'));
            panels.forEach(panel => panel.setAttribute('hidden', true));

            clickedTab.setAttribute('aria-selected', 'true');
            animateIcon(clickedTab);
            const targetPanel = document.getElementById(clickedTab.getAttribute('aria-controls'));
            if (targetPanel) {
                targetPanel.removeAttribute('hidden');
            }
        });

        const counterObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const counters = entry.target.querySelectorAll('.data-proof__number');
                    counters.forEach(counter => {
                        const target = parseInt(counter.dataset.target, 10);
                        animateCounter(counter, target);
                    });
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.5 });

        counterObserver.observe(tabsWrapper);
    }

    /**
     * Lógica da Central de Operações (Atuação Geográfica)
     */
    const mapContainer = document.getElementById('map');
    if (mapContainer && typeof L !== 'undefined') {

        const map = L.map('map').setView([-23.32, -47.38], 10);

        L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
            subdomains: 'abcd',
            maxZoom: 20
        }).addTo(map);

        const cities = [
            { name: 'Itu', coords: [-23.2647, -47.2993], info: "Sede: +200 atendimentos no último trimestre." },
            { name: 'Salto', coords: [-23.2017, -47.2889], info: "Tempo médio de chegada: 30 min." },
            { name: 'Porto Feliz', coords: [-23.2147, -47.5236], info: "+30 atendimentos no último mês." },
            { name: 'Cabreúva', coords: [-23.3075, -47.1333], info: "Cobertura total em todos os bairros." },
            { name: 'Sorocaba', coords: [-23.5019, -47.4581], info: "Atendimento especializado para indústrias." },
            { name: 'Indaiatuba', coords: [-23.0886, -47.2186], info: "Equipe dedicada para a cidade." }
        ];

        const mainCoverageArea = [
            [-23.18, -47.45], [-23.15, -47.20], [-23.25, -47.10], [-23.35, -47.12], [-23.45, -47.25], [-23.45, -47.50], [-23.35, -47.60]
        ];

        L.polygon(mainCoverageArea, {
            color: 'var(--verde-acao)',
            fillColor: 'var(--verde-acao)',
            fillOpacity: 0.05,
            weight: 2,
            dashArray: '5, 5'
        }).addTo(map);

        const cityListElement = document.getElementById('city-list');
        const searchInput = document.getElementById('city-search');
        const markers = {};

        const truckIcon = L.divIcon({
            className: 'custom-map-marker-truck',
            html: '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="20" viewBox="0 0 200 120">\n' +
                '  <!-- Tanque traseiro -->\n' +
                '  <rect x="20" y="40" width="120" height="50" rx="8" fill="#004085"/>\n' +
                '  \n' +
                '  <!-- Cabine -->\n' +
                '  <rect x="140" y="50" width="40" height="40" rx="5" fill="#0056b3"/>\n' +
                '  \n' +
                '  <!-- Vidro da cabine (branco acinzentado) -->\n' +
                '  <rect x="145" y="55" width="25" height="20" rx="2" fill="#e0e0e0"/>\n' +
                '  \n' +
                '  <!-- Roda traseira -->\n' +
                '  <circle cx="60" cy="100" r="15" fill="#333"/>\n' +
                '  <circle cx="60" cy="100" r="7" fill="#777"/>\n' +
                '  \n' +
                '  <!-- Roda dianteira -->\n' +
                '  <circle cx="150" cy="100" r="15" fill="#333"/>\n' +
                '  <circle cx="150" cy="100" r="7" fill="#777"/>\n' +
                '</svg>\n',
            iconSize: [28, 28],
            iconAnchor: [14, 14]
        });

        function renderCityList(citiesToRender) {
            cityListElement.innerHTML = '';
            citiesToRender.forEach(city => {
                const listItem = document.createElement('li');
                const button = document.createElement('button');
                button.textContent = city.name;
                button.dataset.city = city.name;
                listItem.appendChild(button);
                cityListElement.appendChild(listItem);
            });
        }

        cities.forEach(city => {
            const marker = L.marker(city.coords, { icon: truckIcon }).addTo(map)
                .bindPopup(`<b>${city.name}</b><br>${city.info}`);
            markers[city.name] = marker;
        });

        renderCityList(cities);

        cityListElement.addEventListener('click', (e) => {
            if (e.target && e.target.tagName === 'BUTTON') {
                const cityName = e.target.dataset.city;
                const city = cities.find(c => c.name === cityName);
                if (city) {
                    map.flyTo(city.coords, 13, { duration: 1 });
                    markers[cityName].openPopup();
                }
            }
        });

        cityListElement.addEventListener('mouseover', (e) => {
            if (e.target && e.target.tagName === 'BUTTON') {
                const cityName = e.target.dataset.city;
                const marker = markers[cityName];
                if (marker && marker._icon) {
                    marker._icon.classList.add('is-hovered');
                }
            }
        });

        cityListElement.addEventListener('mouseout', (e) => {
            if (e.target && e.target.tagName === 'BUTTON') {
                const cityName = e.target.dataset.city;
                const marker = markers[cityName];
                if (marker && marker._icon) {
                    marker._icon.classList.remove('is-hovered');
                }
            }
        });

        searchInput.addEventListener('input', (e) => {
            const searchTerm = e.target.value.toLowerCase();
            const filteredCities = cities.filter(city =>
                city.name.toLowerCase().includes(searchTerm)
            );
            renderCityList(filteredCities);
        });
    }

    // Encontra o contêiner do mapa
    var mapContainerHome = document.getElementById('leaflet-map');

    // Verifica se o contêiner do mapa existe antes de inicializar o Leaflet
    if (mapContainerHome) {
        // Inicializa o mapa
        var mapHome = L.map('leaflet-map').setView([-23.2625, -47.2997], 12); // Coordenadas para Itu, Brasil

        // Adiciona a camada de tiles (OpenStreetMap)
        L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(mapHome);

        // Opcional: Adiciona um marcador para Itu
        L.marker([-23.2625, -47.2997]).addTo(mapHome)
            .bindPopup('Atendemos em Itu e Região!')
            .openPopup();
    } else {
        console.warn('Elemento com ID "leaflet-map" não encontrado. O mapa Leaflet não será inicializado.');
    }

    /**
     * Lógica do Carrossel de Depoimentos (Ultimate)
     */
    const carouselWrapper = document.querySelector('.testimonial-carousel-wrapper');
    if (carouselWrapper) {
        const carousel = carouselWrapper.querySelector('.testimonial-carousel');
        const track = carouselWrapper.querySelector('.testimonial-track');
        const slides = Array.from(track.children);
        const nextButton = carouselWrapper.querySelector('.carousel-button.next');
        const prevButton = carouselWrapper.querySelector('.carousel-button.prev');
        const pagination = carouselWrapper.querySelector('.carousel-pagination');

        let slideWidth = slides.length > 0 ? slides[0].getBoundingClientRect().width : 0;
        let currentIndex = 0;
        let isDragging = false;
        let startPos = 0;
        let currentTranslate = 0;
        let prevTranslate = 0;
        let animationID;
        let autoPlayInterval;

        // Criar pontos de paginação
        slides.forEach((_, i) => {
            const button = document.createElement('button');
            button.addEventListener('click', () => {
                goToSlide(i);
                resetAutoPlay();
            });
            pagination.appendChild(button);
        });
        const paginationDots = Array.from(pagination.children);

        function setSlidePosition() {
            track.style.transform = `translateX(${currentTranslate}px)`;
        }

        function updatePagination() {
            paginationDots.forEach(dot => dot.classList.remove('active'));
            if(paginationDots[currentIndex]) {
                paginationDots[currentIndex].classList.add('active');
            }
        }

        function goToSlide(index) {
            if (index < 0 || index >= slides.length) return;
            currentIndex = index;
            currentTranslate = currentIndex * -slideWidth;
            prevTranslate = currentTranslate;
            setSlidePosition();
            updatePagination();
        }

        function handleTouchStart(e) {
            isDragging = true;
            startPos = getPositionX(e);
            animationID = requestAnimationFrame(animation);
            carousel.classList.add('is-grabbing');
            clearInterval(autoPlayInterval);
        }

        function handleTouchMove(e) {
            if (isDragging) {
                const currentPosition = getPositionX(e);
                currentTranslate = prevTranslate + currentPosition - startPos;
            }
        }

        function handleTouchEnd() {
            isDragging = false;
            cancelAnimationFrame(animationID);
            const movedBy = currentTranslate - prevTranslate;

            if (movedBy < -100 && currentIndex < slides.length - 1) currentIndex++;
            if (movedBy > 100 && currentIndex > 0) currentIndex--;

            goToSlide(currentIndex);
            carousel.classList.remove('is-grabbing');
            resetAutoPlay();
        }

        function getPositionX(e) {
            return e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
        }

        function animation() {
            setSlidePosition();
            if(isDragging) requestAnimationFrame(animation);
        }

        function resetAutoPlay() {
            clearInterval(autoPlayInterval);
            autoPlayInterval = setInterval(() => {
                goToSlide((currentIndex + 1) % slides.length);
            }, 5000);
        }

        // Event Listeners
        carousel.addEventListener('mousedown', handleTouchStart);
        carousel.addEventListener('touchstart', handleTouchStart, { passive: true });

        carousel.addEventListener('mousemove', handleTouchMove);
        carousel.addEventListener('touchmove', handleTouchMove, { passive: true });

        carousel.addEventListener('mouseup', handleTouchEnd);
        carousel.addEventListener('mouseleave', handleTouchEnd);
        carousel.addEventListener('touchend', handleTouchEnd);

        nextButton.addEventListener('click', () => {
            goToSlide(currentIndex + 1);
            resetAutoPlay();
        });
        prevButton.addEventListener('click', () => {
            goToSlide(currentIndex - 1);
            resetAutoPlay();
        });

        window.addEventListener('resize', () => {
            slideWidth = slides.length > 0 ? slides[0].getBoundingClientRect().width : 0;
            goToSlide(currentIndex);
        });

        goToSlide(0); // Iniciar no primeiro slide
        resetAutoPlay(); // Iniciar autoplay
    }

    /**
     * Lógica do Acordeão e Filtro de FAQ (Avançado)
     */
    const faqSection = document.getElementById('faq');
    if (faqSection) {
        const searchInput = faqSection.querySelector('#faq-search');
        const faqItems = faqSection.querySelectorAll('.faq-item');
        const noResultsContainer = faqSection.querySelector('#faq-no-results');
        const noResultsQuery = noResultsContainer.querySelector('span');

        // Lógica do Acordeão
        faqItems.forEach(item => {
            const button = item.querySelector('.faq-question button');
            const answer = item.querySelector('.faq-answer');

            button.addEventListener('click', () => {
                if (item.hidden) return;

                const isOpening = !item.classList.contains('is-open');

                faqItems.forEach(otherItem => {
                    if (otherItem.classList.contains('is-open')) {
                        otherItem.classList.remove('is-open');
                        otherItem.querySelector('button').setAttribute('aria-expanded', 'false');
                        otherItem.querySelector('.faq-answer').setAttribute('hidden', '');
                    }
                });

                if (isOpening) {
                    item.classList.add('is-open');
                    button.setAttribute('aria-expanded', 'true');
                    answer.removeAttribute('hidden');
                }
            });
        });

        // Lógica do Filtro/Busca
        if (searchInput) {
            searchInput.addEventListener('input', () => {
                const query = searchInput.value.toLowerCase().trim();
                let visibleItems = 0;

                faqItems.forEach(item => {
                    const keywords = item.dataset.keywords || '';
                    const questionText = item.querySelector('.faq-question button').textContent.toLowerCase();
                    const isMatch = keywords.includes(query) || questionText.includes(query);

                    if (isMatch) {
                        item.hidden = false;
                        visibleItems++;
                    } else {
                        item.hidden = true;
                        if (item.classList.contains('is-open')) {
                            item.classList.remove('is-open');
                            item.querySelector('button').setAttribute('aria-expanded', 'false');
                            item.querySelector('.faq-answer').setAttribute('hidden', '');
                        }
                    }
                });

                if (visibleItems === 0 && query !== '') {
                    noResultsQuery.textContent = query;
                    noResultsContainer.hidden = false;
                } else {
                    noResultsContainer.hidden = true;
                }
            });
        }
    }

    const hamburgerButton = document.querySelector('.hamburger-button');
    const navMenu = document.querySelector('.nav-menu');
    const body = document.body;

    /* ==============================================
   APPEND: LÓGICA DO MENU HAMBÚRGUER
   ============================================== */
    if (hamburgerButton && navMenu) {
        hamburgerButton.addEventListener('click', () => {
            // Alterna a classe no body para controlar o estado do menu e o scroll da página
            body.classList.toggle('mobile-menu-open');

            // Verifica o estado atual para definir os atributos ARIA
            const isMenuOpen = body.classList.contains('mobile-menu-open');
            hamburgerButton.setAttribute('aria-expanded', isMenuOpen);

            if (isMenuOpen) {
                hamburgerButton.setAttribute('aria-label', 'Fechar menu');
            } else {
                hamburgerButton.setAttribute('aria-label', 'Abrir menu');
            }
        });

        // Opcional: Fechar o menu ao clicar em um link (útil para one-page sites, mas bom ter)
        navMenu.querySelectorAll('a').forEach(link => {
            link.addEventListener('click', () => {
                if (body.classList.contains('mobile-menu-open')) {
                    body.classList.remove('mobile-menu-open');
                    hamburgerButton.setAttribute('aria-expanded', 'false');
                    hamburgerButton.setAttribute('aria-label', 'Abrir menu');
                }
            });
        });
    }

    document.querySelectorAll('.tag-pill').forEach(pill => {
        pill.addEventListener('mousemove', e => {
            const rect = pill.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            pill.style.setProperty('--glow-x', `${(x / rect.width) * 100}%`);
            pill.style.setProperty('--glow-y', `${(y / rect.height) * 100}%`);
        });
    });

});




